import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DIET_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDietSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_DIET_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateDietSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.diets.diet,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DIET_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateDietSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_DIET_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateDietSimpleDetailsMutation
